export default __webpack_public_path__ + "static/N0175-8aa95e9b494751127378cd5c1eb7eb34.png";